import axios from 'axios';
import camelize from 'camelize';
import snakeCaseKeys from 'snakecase-keys';

export interface ApiError {
  code?: string;
  title?: string;
}

const host: string | undefined = process.env.REACT_APP_API_BASE_URL;

const instance = axios.create({
  baseURL: `${host}/api/v1/`,
  withCredentials: true,
  validateStatus: function (status) {
    return status >= 200 && status < 300; // default
  },
});

instance.interceptors.request.use(async config => {
  config.data = snakeCaseKeys({ ...config.data });
  config.params = snakeCaseKeys({ ...config.params });

  return config;
});

instance.interceptors.response.use(response => {
  const data = camelize(response.data);

  return { ...response, data };
});

export default instance;
